import { useNavigate, useLocation } from "react-router-dom";
import { FileText } from "lucide-react";
import { isTodayQuoteRoute } from "@/components/TodayQuoteBar";

/**
 * Sticky 'Request a Quote' floating CTA — mobile only.
 * Routes to /#quote (homepage anchor) so the existing scroll handler
 * in Index.tsx smooth-scrolls to the RequestQuote section.
 */
const StickyQuoteCTA = () => {
  const navigate = useNavigate();
  const location = useLocation();

  if (isTodayQuoteRoute(location.pathname)) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === "/") {
      document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#quote");
    }
  };

  return (
    <a
      href="/#quote"
      onClick={handleClick}
      aria-label="Get Quote"
      className="md:hidden fixed bottom-6 left-6 z-50 inline-flex min-h-12 items-center gap-2 bg-accent text-accent-foreground font-display font-semibold text-sm px-5 py-3 rounded-full shadow-lg hover:shadow-xl hover:brightness-110 active:scale-95 transition-all duration-300"
    >
      <FileText className="w-4 h-4" />
      Get Quote
    </a>
  );
};

export default StickyQuoteCTA;
